import { render, staticRenderFns } from "./NomCateg.vue?vue&type=template&id=3bdbeb2e&scoped=true&"
import script from "./NomCateg.ts?vue&type=script&lang=ts&"
export * from "./NomCateg.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bdbeb2e",
  null
  
)

export default component.exports
import {QTable,QBtn,QTooltip,QSpace,QInput,QIcon,QTr,QTd,QToggle,QDialog,QCard,QBar,QCardSection,ClosePopup} from 'quasar'
component.options.components = Object.assign({QTable,QBtn,QTooltip,QSpace,QInput,QIcon,QTr,QTd,QToggle,QDialog,QCard,QBar,QCardSection}, component.options.components || {})
component.options.directives = Object.assign({ClosePopup}, component.options.directives || {})
